import { render, staticRenderFns } from "./AdministerCards.vue?vue&type=template&id=30eb218c&scoped=true"
import script from "./AdministerCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdministerCards.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/cards/styles/administer-cards-style.scss?vue&type=style&index=0&id=30eb218c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eb218c",
  null
  
)

/* custom blocks */
import block0 from "@/components/cards/locales/i18n-administer-cards.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fcards%2FAdministerCards.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports